import { method } from "lodash"

export default {
  props: [
    'plate',
    'brand',
    'model',
    'type'
  ],
  data() {
    return {
      plate: this.plate,
      brand: this.brand,
      model: this.model,
      plateExibe: this.plate
    }
  },

  mounted() {

    this.verificarPlaca();
    this.salvaPlaca();
  },

  methods: {
     verificarPlaca() {
      if (this.plateExibe.length === 7 && isNaN(this.plateExibe.charAt(4))) {
           this.plateExibe = this.plateExibe.substring(0, 3) + "" + this.plateExibe.substring(3);
      } else {
        this.plateExibe = this.plateExibe.substring(0, 3) + "-" + this.plateExibe.substring(3);
      }
    },

    salvaPlaca() {
      this.plate = this.plate.substring(0, 3) + "-" + this.plate.substring(3);
    }
  },


}



// WEBPACK FOOTER //
// ./src/components/Pages/Adhesion/form-modal/form-modal.js